import React from "react";
import Slider from "react-slick";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PosterImg from "../../assests/sliderImages/banner2.webp";
import maan_tikkaImg from "../../assests/collectionImg/maag tikka.jpeg";
import ringImg from "../../assests/collectionImg/ring.webp";
import mangalsutraImg from "../../assests/collectionImg/mangalsutra.jpg";
import hath_panImg from "../../assests/collectionImg/hath pan.jpg";
import braceletImg from "../../assests/collectionImg/bangle.webp";
import necklaceImg from "../../assests/collectionImg/necklace.jpg";
import earningImg from "../../assests/collectionImg/earing.jpg";
// 💡 NEW IMPORT: ShopContext से Add to Cart फंक्शन के लिए
import { useShop } from '../../context/ShopContext'; 

interface ProductCardProps {
  image: string;
  title: string;
  price: string;
  oldPrice: string;
  reviews: string;
  rating: number;
  id: number;
  stone_metal: string; 
  // ✅ FIX: type updated to accept the object
  onAddToCart: (item: any) => Promise<void>;
}

const ProductCard: React.FC<ProductCardProps> = ({ 
    image, 
    title, 
    price, 
    oldPrice, 
    reviews, 
    rating,
    onAddToCart, 
    id, 
    stone_metal 
}) => {
    // ✅ FIX: Changed to send the proper object format
    const handleAddToCart = () => {
        const numericPrice = Number(price.replace(/[^0-9.-]+/g,""));
        onAddToCart({
            productId: String(id),
            productTitle: title,
            productImage: image,
            price: numericPrice,
            quantity: 1
        });
    };

  return (
    <div className="relative w-64 bg-white shadow-lg rounded-lg overflow-hidden flex flex-col group">
      <div className="relative overflow-hidden">
        <img src={image} alt={title} className="w-full h-40 object-cover" />
        {/* <button className="absolute top-2 right-2 p-2 bg-white rounded-full shadow-md opacity-0 group-hover:opacity-100 transition">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="red" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M4 8c0-2.21 1.79-4 4-4s4 1.79 4 4h0c0-2.21 1.79-4 4-4s4 1.79 4 4c0 5-8 10-8 10s-8-5-8-10z" />
          </svg>
        </button> */}
        <div className="absolute bottom-0 left-0 w-full flex justify-center transform translate-y-full opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
          {/* 🎯 UPDATED BUTTON: onClick हैंडलर जोड़ा गया */}
          {/* <button 
            onClick={handleAddToCart} // ✅ UPDATED LOGIC
            className="bg-[#D8B28D] text-white py-2 px-6 rounded-full flex items-center group-hover:animate-bounce"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5 mr-2">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.2 6h12.4M7 13h10m-6 6a1 1 0 102 0 1 1 0 00-2 0z" />
            </svg>
            Add to Cart
          </button> */}
        </div>
      </div>

      <div className="p-4 flex-1 flex flex-col justify-between">
        <div>
          <h3 className="text-lg font-semibold">{title}</h3>
          <div className="flex items-center mt-1">
            <p className="text-gray-400 line-through mr-2">{oldPrice}</p>
            <p className="text-gray-900 font-bold">{price}</p>
          </div>
          <div className="flex items-center mt-2">
            {Array.from({ length: 5 }, (_, index) => (
              <svg key={index} xmlns="http://www.w3.org/2000/svg"
                fill={index < Math.round(rating) ? "#A67C4F" : "none"}
                viewBox="0 0 24 24" stroke="#A67C4F" className="w-4 h-4">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M12 17.27l5.18 3.73-1.64-5.81 4.46-3.73-5.82-.46L12 5.1 9.82 10l-5.82.46 4.46 3.73-1.64 5.81L12 17.27z" />
              </svg>
            ))}
            <span className="text-gray-600 text-sm ml-2">({reviews} reviews)</span>
          </div>
        </div>
      </div>

      {/* Discount Moving Text */}
      <div className="w-full overflow-hidden bg-gray-800">
        <div className="whitespace-nowrap animate-marquee text-white text-sm py-2">
          Buy 2 Get 3 Offer! Limited Time Deal! 🚀 | Hurry Up! 🔥
        </div>
      </div>
    </div>
  );
};

// Custom Arrow Buttons (Unchanged)
const NextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div className="absolute -right-6 top-1/3 z-10 cursor-pointer" onClick={onClick}>
      <ChevronRight className="w-8 h-8 text-amber-600 hover:text-amber-800" />
    </div>
  );
};
const PrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div className="absolute -left-6 top-1/3 z-10 cursor-pointer" onClick={onClick}>
      <ChevronLeft className="w-8 h-8 text-amber-600 hover:text-amber-800" />
    </div>
  );
};

// --- productSections data (UPDATED with id and stone_metal) ---
// Note: id (srno) और stone_metal (product_type) की जरूरत है CartRequest.java DTO के लिए।
const productSections = [
    {
      title: "Featured Earrings",
      products: [
        { id: 101, stone_metal: "Gold", image: earningImg, title: "Gold Jhumka Earrings", price: "₹24,500", oldPrice: "₹26,000", reviews: "120", rating: 4.5 },
        { id: 102, stone_metal: "Gold", image: maan_tikkaImg, title: "Diamond Studs", price: "₹45,000", oldPrice: "₹50,000", reviews: "90", rating: 4.8 },
        { id: 103, stone_metal: "Gold", image: ringImg, title: "Kundan Hoops", price: "₹18,000", oldPrice: "₹20,000", reviews: "65", rating: 4.2 },
        { id: 104, stone_metal: "Silver", image: mangalsutraImg, title: "Traditional Bali", price: "₹15,000", oldPrice: "₹16,500", reviews: "150", rating: 4.7 },
        { id: 105, stone_metal: "Gold", image: hath_panImg, title: "Antique Danglers", price: "₹30,000", oldPrice: "₹32,000", reviews: "78", rating: 4.6 },
        { id: 106, stone_metal: "Silver", image: braceletImg, title: "Modern Drop", price: "₹12,000", oldPrice: "₹13,500", reviews: "105", rating: 4.3 },
      ]
    },
    {
      title: "Best Selling Necklaces",
      products: [
        { id: 201, stone_metal: "Gold", image: necklaceImg, title: "Pearl Choker", price: "₹55,000", oldPrice: "₹60,000", reviews: "180", rating: 4.9 },
        { id: 202, stone_metal: "Gold", image: ringImg, title: "Gold Long Chain", price: "₹85,000", oldPrice: "₹92,000", reviews: "110", rating: 4.4 },
        { id: 203, stone_metal: "Gold", image: mangalsutraImg, title: "Temple Pendant Set", price: "₹72,000", oldPrice: "₹78,000", reviews: "95", rating: 4.7 },
        { id: 204, stone_metal: "Silver", image: braceletImg, title: "Diamond Solitaire", price: "₹1,20,000", oldPrice: "₹1,35,000", reviews: "50", rating: 4.8 },
      ]
    },
];
// --- End productSections data ---


const ProductPage: React.FC = () => {
  // 💡 NEW CODE: Context से addItemToCart फंक्शन लेना
  const { addItemToCart } = useShop();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="py-10 px-5 bg-gray-50">
      {productSections.map((section, idx) => (
        <div key={idx} className="mb-12">
          <h2 className="text-2xl font-bold mb-6 text-gray-800">{section.title}</h2>
          
          <div className="relative px-4"> 
            <Slider {...settings}>
              {section.products.map((product, index) => (
                <div key={index} className="px-9">
                  <ProductCard
                    // ✅ NEW PROPS
                    id={product.id} 
                    stone_metal={product.stone_metal}
                    // Existing props
                    image={product.image}
                    title={product.title}
                    price={product.price}
                    oldPrice={product.oldPrice}
                    reviews={product.reviews}
                    rating={product.rating}
                    // ✅ UPDATED PROP: addItemToCart फंक्शन पास करना
                    // अब ProductCardProps का टाइप मैच हो रहा है
                    onAddToCart={addItemToCart} 
                  />
                </div>
              ))}
            </Slider>
          </div>

          {idx === 0 && (
            <div className="my-12">
              <img
                src={PosterImg}
                alt="Sardar Jewellers Poster"
                className="w-full h-auto object-cover rounded-lg"
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ProductPage;